// import React, { useContext, useEffect, useState } from 'react';
// import "./BudgetEstimation.css";
// import Application from "../../StateContext/Application";
// import { apiurl } from '../../../../path';
// import { Back32, Cancel32, ProposalCreation32, submit } from '../../../../public/LoginImages/importimages';
// import * as XLSX from 'xlsx';
// import * as exifr from 'exifr';
// import { useLanguage } from '../../../../lang/langcontext/LanguageContext';

// const DemandRequest = () => {
//     const { language, toggleLanguage, t } = useLanguage();
//     const operation = useContext(Application);

//     const { GetProjectInfo, GetBudgetHeadInfo, DemandRequest } = operation;

//     const [projectId, setProjectId] = useState([]);
//     const [HeadId, setHeadID] = useState([]);
//     const [editIndex, setEditIndex] = useState(null);
//     const [isEditing, setIsEditing] = useState(false);
//     const [indexofediting, setIndexofEditing] = useState(null);
//     const [relatedHeadID, setRelatedHeadID] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [WorkNameList, setWorkNameList] = useState([]);
//     const [HeadCode, setHeadCode] = useState([]);
//     const [district, setDistrict] = useState([]);
//     const [selectedUploadId, setSelectedUploadID] = useState();
//     const [FetchedImages, setFetchedImages] = useState([]);
//     const [showSpecific, setShowSpecific] = useState(0);
//     const [selectedImage, setSelectedImage] = useState(null);
//     const [DeemandData, setDeemandData] = useState([]);
//     const [isDisabled, setIsDisabled] = useState(false);

//     // New state to prevent double clicking on ADD button
//     const [isAdding, setIsAdding] = useState(false);

//     const [processedProposalCopy, setProcessedProposalCopy] = useState(null);
//     const [fileProcessing, setFileProcessing] = useState(false);
//     const [data, setData] = useState({
//         HeadCode: "",
//         ProjectID: '',
//         ProjectName: '',
//         ProjectCost: "0",
//         talulka: "",
//         piu: "",
//         GRCopy: "",
//         FinancialYear: '',
//         BudgetHeadID: '',
//         BudgetHeadName: "",
//         BudgetHeadType: "",
//         DemandRequestamount: null,
//         workName: "",
//         ProposalWorkName: "",
//         remark: "",
//         WorKOrderAmount: "",
//         PhysicalValue: "",
//     });

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         console.log(name, value);

//         setData({ ...data, [name]: value });
//     }


//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (tableData && tableData.length <= 0) {
//             return alert("No Data Inserted !!!");
//         }

//         try {
//             setLoading(true);
//             const res = await DemandRequest(tableData);
//             alert(res.message);
//             window.location.reload();
//         } catch (error) {
//             console.log(error)
//             setLoading(false);
//         } finally {
//             setLoading(false);
//         }

//     };

//     // Fetching

//     const FetchData = async () => {

//         try {
//             let res = await GetProjectInfo('null', "all");
//             let res1 = await GetBudgetHeadInfo('null', "all");
//             let res3 = await GetBudgetHeadInfo('null', "AllHeadCode");

//             console.log("district ------------ ", res3);
//             setProjectId(res);
//             setHeadID(res1);
//             // setWorkNameList(res2);
//             // setDistrict(res2)
//             // setWorkNameList(res2);
//             // setDistrict(res2)
//             setHeadCode(res3);
//         }
//         catch (err) {
//             console.log(err);
//         }
//     }


//     const HeadIDFetchOperation = async (ID, IDtype) => {
//         try {
//             console.log(ID);
//             if (IDtype == "ProjectId") {
//                 let res1 = await GetProjectInfo(ID, "id");
//                 console.log("Project ID ingo :: ", res1);
//                 let projectData = res1[0];
//                 console.log("project data i sleected ", projectData);

//                 let apple = [...new Map(HeadId.filter(item => item.ProjectName === projectData.ProjectName).map(item => [item.HeadName, item])).values()];
//                 console.log("Head related to project ", apple)
//                 setRelatedHeadID(apple);


//                 setData((prev) => ({
//                     ...prev,
//                     FinancialYear: projectData.FinancialYear,
//                     ProjectName: projectData.ProjectName,
//                     ProjectID: projectData.ProjectId,
//                     ProjectCost: projectData.ProjectCost,
//                     piu: projectData.PIU,
//                     GRCopy: projectData.GRCopy
//                 }))
//             } else if (IDtype == "HeadID") {
//                 let res1 = await GetBudgetHeadInfo(ID, 'id');
//                 console.log("Head ID info ", res1);
//                 let HeadData = res1[0];
//                 setData((prev) => ({
//                     ...prev,
//                     BudgetHeadID: HeadData.HeadID,
//                     BudgetHeadName: HeadData.HeadName,
//                     BudgetHeadType: HeadData.HeadType
//                 }))
//             }
//         }
//         catch (err) {
//             console.log(err);
//         }
//     }

//     useEffect(() => {
//         FetchData();
//     }, [])


//     const [tableData, setTableData] = useState([]);


//     const FetchDeemandRequest = async () => {
//         let HeadID = {
//             HeadCode: data.HeadCode,
//             FinancialYear: data.FinancialYear,
//             ProposalWorkName: data.ProposalWorkName,
//             PhysicalValue: data.PhysicalValue
//         };

//         let res2 = await GetBudgetHeadInfo(HeadID, "GetSpecifcDetailForDemandRequest");
//         if (!res2 || res2.length === 0) {
//             alert("No progress data found for this work order");
//             setDeemandData([]);
//             setData(prev => ({ ...prev, PhysicalValue: "" }));
//             return;
//         }

//         const { ApprovedWorkAmount } = res2[0];
//         let response = await GetBudgetHeadInfo(HeadID, "GetSpecifcDemandRequest");
//         setDeemandData(response);

//         const currentPhysical = Number(data.PhysicalValue);
//         const Approved = Number(ApprovedWorkAmount);
//         const validSteps = [30, 50, 100];

//         // 🧩 No previous demands
//         let hasShownAlert = false;
//         if (!response || response.length === 0) {
//             if (!hasShownAlert) {
//                 hasShownAlert = true;
//                 const allowedAmount = (Approved * 30) / 100;
//                 if (currentPhysical !== 30) {
//                     alert("No previous demand requests, creating 30% demand.");
//                 }
//                 setData(prev => ({ ...prev, PhysicalValue: 30, DemandRequestamount: allowedAmount }));
//             }
//             return;
//         }

//         // ✅ Check if already created
//         if (response.some(item => Number(item.PhysicalValue) === currentPhysical)) {
//             alert(`You have already created a demand request for ${currentPhysical}%.`);
//             setData(prev => ({ ...prev, PhysicalValue: "" }));
//             return;
//         }

//         // ✅ Find the highest existing physical value
//         const createdSteps = response.map(item => Number(item.PhysicalValue));
//         const maxCreated = Math.max(...createdSteps);
//         console.log("Max created physical:", maxCreated);

//         // 🧩 Rule: must have previous step
//         const currentIndex = validSteps.indexOf(currentPhysical);
//         const prevStep = validSteps[currentIndex - 1];

//         if (currentIndex > 0 && !createdSteps.includes(prevStep)) {
//             alert(`You must first create a demand request for ${prevStep}%.`);
//             setData(prev => ({ ...prev, PhysicalValue: prevStep }));
//             return;
//         }

//         // ✅ All checks passed — calculate allowed %
//         const allowedPercentage = currentPhysical - maxCreated;
//         const allowedAmount = (Approved * allowedPercentage) / 100;

//         console.log("Allowed %:", allowedPercentage);
//         console.log("Allowed Amount:", allowedAmount);

//         setData(prev => ({
//             ...prev,
//             DemandRequestamount: allowedAmount,
//             PhysicalValue: currentPhysical
//         }))
//         // Validation
//         if (Number(data.DemandRequestamount) > allowedAmount) {
//             alert(
//                 `Demand Request Amount cannot exceed ${allowedPercentage}% of Work Order Amount (${allowedAmount}).`
//             );
//             return;
//         }

//     }

//     useEffect(() => {
//         if (data.PhysicalValue) {
//             FetchDeemandRequest();
//         }
//     }, [data.HeadCode, data.FinancialYear, data.ProposalWorkName, data.PhysicalValue]);


//     const AddinTableOperation = async (e) => {
//         e.preventDefault();

//         // Prevent double execution
//         if (isAdding) return;

//         if (!data.DemandRequestamount) {
//             return alert("Please Enter The Demand Request Amount!");
//         }
//         if (!data.PhysicalValue) {
//             return alert("Please Enter The Physical Value!");
//         }

//         setIsAdding(true); // Start loading state

//         try {
//             let HeadID = {
//                 HeadCode: data.HeadCode,
//                 FinancialYear: data.FinancialYear,
//                 ProposalWorkName: data.ProposalWorkName,
//                 PhysicalValue: data.PhysicalValue
//             }
//             let res2 = await GetBudgetHeadInfo(HeadID, "GetSpecifcDetailForDemandRequest");
//             if (!res2 || res2.length === 0) {
//                 alert("No progress data found for this work order");
//                 return;
//             }
//             const { ApprovedWorkAmount, RemainingAmount, PaidAmount, BillRemainingAmount, BillPaidAmount, TechnicalUID, UploadID, talulka, physicalValue, WorkOrder_TechnicalID, Progress_TechnicalID, WorkName } = res2[0];
//             console.log("Result :: ", res2);

//             let obj = {
//                 year: data.FinancialYear,
//                 headCode: data.HeadCode,
//                 workName: WorkName,
//                 ProposalWorkName: data.ProposalWorkName,
//                 district: talulka,
//                 amount: data.DemandRequestamount,
//                 TechnicalUID: WorkOrder_TechnicalID,
//                 // UID: `Admin_UID-${Math.floor(Math.random() * 10000)}`,
//                 PhysicalProgressUID: UploadID,
//                 physicalValue: data.PhysicalValue,
//                 WorkOrderAmount: ApprovedWorkAmount,
//                 ExpenditureAmount: BillPaidAmount,
//                 ApprovedDemandRequest: data.DemandRequestamount,
//                 AvailableWorkOrderAmount: BillRemainingAmount,
//                 AvailableAmountForDemandRequest: ApprovedWorkAmount - data.DemandRequestamount,
//                 currentDate: new Date().toISOString()

//             }


//             let isDuplicate = tableData.some((entry) =>
//                 entry.year === obj.year &&
//                 entry.headCode === obj.headCode &&
//                 entry.ProposalWorkName === obj.ProposalWorkName &&
//                 entry.physicalValue === obj.physicalValue
//             );

//             if (isDuplicate) {
//                 alert("Duplicate entry !! This data already exists in the table.");
//                 return;
//             }

//             setTableData((prev) => [...prev, obj]);
//         }
//         catch (err) {
//             console.log("Error :: ", err);
//         } finally {
//             setIsAdding(false); // Stop loading state
//         }
//     }

//     console.log("table Data :: ", tableData);

//     const handleEdit = (e, index) => {
//         e.preventDefault();
//         const item = tableData[index];
//         console.log("table i selected :: ", item)
//         setEditIndex(item);
//         setIndexofEditing(index);
//     };

//     const handleDelete = (e, index) => {
//         e.preventDefault();
//         const updated = tableData.filter((_, i) => i !== index);
//         setTableData(updated);
//     };


//     const handelchangeTablre = (e) => {
//         e.preventDefault();
//         const updatedData = [...tableData];
//         updatedData[indexofediting] = editIndex;
//         setTableData(updatedData);
//         console.log("Editted Index :: ", editIndex);
//         setEditIndex(null);
//         setIndexofEditing(null);
//         setShowSpecific(0);
//     };

//     const handleClosetheSpecificwindow = (e) => {
//         e.preventDefault();
//         setEditIndex(null);
//         setIndexofEditing(null);
//         setShowSpecific(0);
//     };

//     const getAllFinancialYears = () => {
//         const years = [];
//         for (let year = 2024; year <= 2025; year++) {
//             const next = (year + 1).toString();
//             years.push(`${year}-${next}`);
//         }
//         return years;
//     };


//     const fetchSpecficUploadPhoto = async (e, id) => {
//         e.preventDefault();
//         try {
//             let res = await GetBudgetHeadInfo(id, "GetSpecificUploadImagesfromProgressTableUsingWorkOrderNo")
//             setFetchedImages(res);
//             setSelectedUploadID(id);
//             setShowSpecific(1);
//         }
//         catch (err) {
//             console.log(err);
//         }
//     };

//     const FetchSpecificWorkOrder = async (FinancialYear, Head) => {
//         console.log(FinancialYear, Head);

//         try {
//             let res = await GetBudgetHeadInfo("null", "GetAllWorknameFromWorkOrderDetail")
//             console.log("res", res);

//             let newres = res.filter((item) => item.ProposalYear == FinancialYear && item.HeadCode == Head);
//             console.log(newres);

//             setWorkNameList(newres);
//             setDistrict(newres);
//         }
//         catch (err) {
//             console.log(err);
//         }
//     }

//     useEffect(() => {
//         if (data.FinancialYear && data.HeadCode) {
//             FetchSpecificWorkOrder(data.FinancialYear, data.HeadCode);
//         }
//     }, [data.FinancialYear, data.HeadCode]);



//     useEffect(() => {
//         if (data.ProposalWorkName !== "") {
//             let info = WorkNameList.filter((val) => val.ProposalID?.trim() == data.ProposalWorkName);
//             let workorderamount = info[0]?.ApprovedWorkAmount || 0;

//             setData({
//                 ...data,
//                 WorKOrderAmount: workorderamount
//             });
//         }
//     }, [data.ProposalWorkName]);


//     const processFile = (file) => {
//         return new Promise(async (resolve, reject) => {
//             try {
//                 const imageTypes = ["image/jpeg", "image/jpg", "image/png"];
//                 const pdfTypes = ["application/pdf"];

//                 // ===== IMAGE FILE =====
//                 if (imageTypes.includes(file.type)) {
//                     const exifData = await exifr.parse(file, ['GPSLatitude', 'GPSLongitude']);
//                     if (exifData && (exifData.GPSLatitude || exifData.GPSLongitude)) {
//                         console.warn(`⚠️ EXIF GPS data found in ${file.name}. It will be stripped.`);
//                     }

//                     const reader = new FileReader();
//                     reader.onload = (e) => {
//                         const img = new Image();
//                         img.onload = () => {
//                             const canvas = document.createElement("canvas");
//                             canvas.width = img.width;
//                             canvas.height = img.height;
//                             const ctx = canvas.getContext("2d");
//                             ctx.drawImage(img, 0, 0);

//                             canvas.toBlob((blob) => {
//                                 const cleanedFile = new File([blob], file.name, { type: file.type });
//                                 resolve(cleanedFile);
//                             }, file.type);
//                         };


//                         img.onerror = reject;
//                         img.src = e.target.result;
//                     };
//                     reader.onerror = reject;
//                     reader.readAsDataURL(file);
//                     return;
//                 }

//                 // ===== PDF FILE =====
//                 if (pdfTypes.includes(file.type)) {
//                     const reader = new FileReader();
//                     reader.onload = (e) => {
//                         // Read as ArrayBuffer instead of text
//                         const arrayBuffer = e.target.result;
//                         const uint8Array = new Uint8Array(arrayBuffer);

//                         // Convert to string for pattern matching
//                         const textContent = new TextDecoder('latin1').decode(uint8Array);

//                         // More precise patterns with context
//                         const dangerousPatterns = [
//                             /\/JavaScript\s*<</, // JavaScript object definition
//                             /\/JS\s*\(/, // JS action with parenthesis
//                             /\/AA\s*<</, // Additional Actions object
//                             /\/OpenAction\s*<</, // OpenAction object
//                             /\/Launch\s*<</, // Launch action object
//                             /\/RichMedia\s*<</ // RichMedia object
//                         ];

//                         const isMalicious = dangerousPatterns.some(pattern => pattern.test(textContent));

//                         if (isMalicious) {
//                             alert(`⚠️ Suspicious PDF detected in file "${file.name}". The page will reload.`);

//                             return reject(new Error("Malicious PDF detected"));
//                         }

//                         resolve(file); // safe PDF
//                     };
//                     reader.onerror = reject;
//                     reader.readAsArrayBuffer(file); // Changed from readAsText
//                     return;
//                 }

//                 // ===== OTHER FILE TYPES =====
//                 resolve(file);

//             } catch (error) {
//                 console.error("Error processing file:", error);
//                 reject(error);
//             }
//         });
//     };

//     // handle file input changes and process files immediately to validate / strip metadata
//     const handelDemandFile = async (e) => {
//         const file = e.target.files && e.target.files[0];
//         if (!file) {
//             setProcessedProposalCopy(null);
//             return;
//         }
//         setFileProcessing(true);
//         try {
//             const cleaned = await processFile(file);
//             setProcessedProposalCopy(cleaned);
//         } catch (err) {
//             console.error('Error processing ProposalCopy:', err);
//             alert('Invalid Proposal Copy file. Please choose a different file.');
//             e.target.value = '';
//             setProcessedProposalCopy(null);
//         } finally {
//             setFileProcessing(false);
//         }
//     };

//     const ResetData = (e) => {
//         e.preventDefault();
//         setData({
//             HeadCode: "",
//             FinancialYear: "",
//             MHUID: "",
//             ProposalWorkName: "",
//             DemandRequestamount: 0,
//             PhysicalValue: "",
//             WorKOrderAmount: 0
//         });
//         setTableData([]);
//         setDeemandData([]);
//     }

//     return (
//         <>
//             {
//                 showSpecific === 0 && (
//                     <div className='col-12 pb-5' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//                         <div className="col-12 m-auto">

//                             {loading && (
//                                 <div
//                                     style={{
//                                         position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
//                                         display: 'flex', justifyContent: 'center', alignItems: 'center'
//                                     }}>
//                                     <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
//                                     <style>
//                                         {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
//                                     </style>
//                                 </div>
//                             )}


//                             <div className="col-12 m-auto my-5 budgetContainer">
//                                 <div className="m-auto my-5 budgetElement">

//                                     <div className="col-12 mb-4 mt-3">
//                                         <div className='col-12' style={{ display: "flex", alignItems: "center" }}>
//                                             < img src="/Bill-files64.png" alt="TechnicalSanction" style={{ width: "32px", height: "32px" }} className='my-auto me-2' />
//                                             <h3 className='text-left fw-bold mt-2'>{t("Demand Request")}</h3>
//                                         </div>
//                                         <div className="col-12 mt-4">
//                                             <p className='py-2 ps-1 fw-bold text-danger' style={{ backgroundColor: "#FBE7E7" }}>{t("Note : Fields marked with * are mandatory")}</p>
//                                         </div>
//                                     </div>

//                                     <form >

//                                         <div className="col-12 elements">
//                                             <div className="row">
//                                                 <div className="col-3 my-auto ">
//                                                     <label className='my-auto'>{t("Approved Year")}<span className='text-danger fw-bold'>*</span></label>
//                                                 </div>
//                                                 <div className="col-7">
//                                                     <select className="form-control" name="FinancialYear" value={data.FinancialYear} onChange={(e) => { handleChange(e) }} required={true} onBlur={handleChange}>
//                                                         <option value="" disabled>{t("Select Year")}</option>
//                                                         {getAllFinancialYears().map((year) => (<option key={year} value={year}>{year}</option>))}
//                                                     </select>
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         <div className="col-12 elements">
//                                             <div className="row">
//                                                 <div className="col-3 my-auto ">
//                                                     <label className='my-auto'>{t("Head")}<span className='text-danger fw-bold'>*</span></label>
//                                                 </div>
//                                                 <div className="col-7">
//                                                     <select name="HeadCode" value={data.HeadCode} className='py-2' onChange={(e) => { handleChange(e) }} required={true} onBlur={handleChange}>
//                                                         <option value="">{t("Select Head Code")}</option>
//                                                         {
//                                                             HeadCode &&
//                                                             HeadCode.map((val, index) => (
//                                                                 <option value={val.HeadID} key={index}>{val.HeadName}</option>
//                                                             ))
//                                                         }
//                                                     </select>
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         {/* <div className="col-12 elements">
//                                             <div className="row">
//                                                 <div className="col-3 my-auto ">
//                                                     <label className='my-auto'>Work Order Name</label>
//                                                 </div>
//                                                 <div className="col-7">
//                                                     <select name="workName" value={data.workName} className='py-2' onChange={handleChange}>
//                                                         <option value="">Select Work Order Name</option>
//                                                         {[
//                                                             ...new Set(
//                                                                 (WorkNameList || []).map((val) => val.WorkName?.trim())
//                                                             ),
//                                                         ].map((uniqueName, index) => (
//                                                             <option value={uniqueName} key={index}>
//                                                                 {uniqueName}
//                                                             </option>
//                                                         ))}
//                                                     </select>
//                                                 </div>
//                                             </div>
//                                         </div> */}


//                                         <div className="col-12 elements">
//                                             <div className="row">
//                                                 <div className="col-3 my-auto ">
//                                                     <label className='my-auto'>{t("MHUID Number")}<span className='text-danger fw-bold'>*</span></label>
//                                                 </div>
//                                                 <div className="col-7">
//                                                     <select name="MHUID" value={data.MHUID} className='py-2' onChange={handleChange}>
//                                                         <option value="">{t("Select MHUID Number")}</option>
//                                                         {
//                                                             WorkNameList &&
//                                                             [...new Map(
//                                                                 WorkNameList
//                                                                     .map((val) => [`${val.ProposalID}`, val])
//                                                             ).values()]
//                                                                 .map((val, index) => (
//                                                                     <option
//                                                                         key={index}
//                                                                         value={val.TechnicalUID}
//                                                                     >
//                                                                         {val.TechnicalUID}
//                                                                     </option>
//                                                                 ))
//                                                         }
//                                                     </select>
//                                                 </div>
//                                             </div>
//                                         </div>


//                                         <div className="col-12 elements">
//                                             <div className="row">
//                                                 <div className="col-3 my-auto ">
//                                                     <label className='my-auto'>{t("Work Name")}<span className='text-danger fw-bold'>*</span></label>
//                                                 </div>
//                                                 <div className="col-7">
//                                                     <select name="ProposalWorkName" value={data.ProposalWorkName} className='py-2' onChange={handleChange}>
//                                                         <option value="">{t("Select Work Name")}</option>
//                                                         {
//                                                             WorkNameList &&
//                                                             [...new Map(
//                                                                 WorkNameList.filter((val) => val.WorkOrder_TechnicalID === data.MHUID)
//                                                                     .map((val) => [`${val.ProposalID}`, val])
//                                                             ).values()]
//                                                                 .map((val, index) => (
//                                                                     <option
//                                                                         key={index}
//                                                                         value={val.ProposalID}
//                                                                     >
//                                                                         {val.ProposalID}
//                                                                     </option>
//                                                                 ))
//                                                         }
//                                                         {/* {[
//                                                             ...new Set(
//                                                                 (WorkNameList || []).map((val) => val.ProposalID?.trim())
//                                                             ),
//                                                         ].map((uniqueName, index) => (
//                                                             <option value={uniqueName} key={index}>
//                                                                 {uniqueName}
//                                                             </option>
//                                                         ))} */}
//                                                     </select>
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         <div className="col-12 elements">
//                                             <div className="row">
//                                                 <div className="col-3 my-auto ">
//                                                     <label className='my-auto'>{t("Select Physical Value")}<span className='text-danger fw-bold'>*</span></label>
//                                                 </div>
//                                                 <div className="col-7">
//                                                     <select name="PhysicalValue" value={data.PhysicalValue} className='py-2' onChange={handleChange}>
//                                                         <option value="">{t("Select Physical Value")}</option>
//                                                         {/* {
//                                                             WorkNameList &&
//                                                             WorkNameList
//                                                                 .filter((val) => val.ProposalID === data.ProposalWorkName)
//                                                                 .map((val, index) => (
//                                                                     <option key={index} value={val.physicalValue}>
//                                                                         {val.physicalValue}%
//                                                                     </option>
//                                                                 ))
//                                                         } */}
//                                                         <option value="30">30</option>
//                                                         <option value="50">50</option>
//                                                         <option value="100">100</option>
//                                                     </select>
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         <div className="col-12 elements">
//                                             <div className="row">
//                                                 <div className="col-3">
//                                                     <label >{t("Work Order Amount")}</label>
//                                                 </div>
//                                                 <div className="col-7">
//                                                     <input className='form-control'
//                                                         type='text'
//                                                         value={data.WorKOrderAmount} placeholder='0' disabled />
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         {
//                                             DeemandData &&
//                                             DeemandData.length > 0 &&
//                                             (
//                                                 <div className="col-12 my-3">
//                                                     <div className="row">

//                                                         <div className='col-12'>
//                                                             <div style={{ overflowX: "auto", maxWidth: "100%" }}>
//                                                                 <h4 className='text-center'>{t("Previous Demand Request Of")} {data.MHUID} </h4>
//                                                                 <table className='m-0 p-0'
//                                                                     style={{ width: '100%', borderCollapse: 'collapse', whiteSpace: "nowrap" }}>
//                                                                     <thead>
//                                                                         <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>

//                                                                             <th style={{ padding: "7px 10px", minWidth: "40px" }}>{t("Sr.No")}</th>
//                                                                             <th style={{ padding: "14px 20px", minWidth: "180px" }}>{t("Work Name")}</th>
//                                                                             <th style={{ padding: "14px 20px", minWidth: "90px" }}>{t("Physical Value in %")}</th>
//                                                                             <th style={{ padding: "14px 20px", minWidth: "90px" }}>{t("MHUID Number")}</th>
//                                                                             <th style={{ padding: "14px 20px", minWidth: "90px" }}>{t("Demand Amount")}</th>
//                                                                         </tr>
//                                                                     </thead>
//                                                                     <tbody>
//                                                                         {
//                                                                             DeemandData.map((val, index) => {
//                                                                                 return (
//                                                                                     <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#c6dae7", height: '2rem' }}>
//                                                                                         <td>{index + 1}</td>
//                                                                                         <td>{val.ProposalWorkName}</td>
//                                                                                         <td>{val.PhysicalValue}</td>
//                                                                                         <td>{val.MHUID}</td>
//                                                                                         <td>{val.DRAmount}</td>
//                                                                                     </tr>

//                                                                                 )
//                                                                             })
//                                                                         }
//                                                                     </tbody>
//                                                                 </table>
//                                                             </div>
//                                                         </div>

//                                                     </div>
//                                                 </div>
//                                             )
//                                         }

//                                         <div className="col-12 elements">
//                                             <div className="row">
//                                                 <div className="col-3 my-auto ">
//                                                     <label className='my-auto'>{t("Demand Request Amount")}</label>
//                                                 </div>
//                                                 <div className="col-7">
//                                                     <input className='form-control'
//                                                         type='text'
//                                                         name='DemandRequestamount'
//                                                         onChange={(e) => {
//                                                             const value = e.target.value;

//                                                             if (!/^\d*\.?\d{0,2}$/.test(value)) return;

//                                                             if (Number(value) > Number(data.WorKOrderAmount)) {
//                                                                 alert("Demand Request Amount cannot be greater than Work Order Amount!");
//                                                                 setData((prev) => ({
//                                                                     ...prev,
//                                                                     DemandRequestamount: prev.DemandRequestamount || "",
//                                                                 }));
//                                                                 return;
//                                                             }
//                                                             else {
//                                                                 setData((prev) => ({
//                                                                     ...prev,
//                                                                     DemandRequestamount: value,
//                                                                 }));
//                                                             }

//                                                         }}
//                                                         value={data.DemandRequestamount}
//                                                         placeholder={t("Amount")} disabled />
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         <div className="col-11 text-end">
//                                             <div className="col-10 m-auto">
//                                                 <button
//                                                     style={{
//                                                         backgroundColor: (isDisabled || isAdding) ? '#ccc' : '#f9a318',
//                                                         width: "6rem",
//                                                         color: 'white',
//                                                         border: 'none',
//                                                         borderRadius: '5px',
//                                                         height: '2rem',
//                                                         cursor: (isDisabled || isAdding) ? 'not-allowed' : 'pointer'
//                                                     }}
//                                                     disabled={isDisabled || isAdding}
//                                                     onClick={AddinTableOperation}
//                                                 >
//                                                     {isAdding ? "Adding..." : t("ADD")}
//                                                 </button>
//                                             </div>
//                                         </div>



//                                         {
//                                             tableData &&
//                                             tableData.length > 0 &&
//                                             (
//                                                 <div className="col-12 my-3">
//                                                     <div className="row">

//                                                         <div className='col-12 tableContainer100'>
//                                                             <div style={{ overflowX: "auto", maxWidth: "100%" }}>
//                                                                 <table className='m-0 p-0'
//                                                                     style={{ width: '100%', borderCollapse: 'collapse', whiteSpace: "nowrap" }}>
//                                                                     <thead>
//                                                                         <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>

//                                                                             <th style={{ padding: "7px 10px", minWidth: "40px" }}>{t("Sr.No")}</th>
//                                                                             <th style={{ padding: "14px 20px", minWidth: "180px" }}>{t("Work Name")}</th>
//                                                                             <th style={{ padding: "14px 20px", minWidth: "180px" }}>{t("Proposal Work Name")}</th>
//                                                                             <th style={{ padding: "14px 20px", minWidth: "90px" }}>{t("Physical Value")}</th>
//                                                                             <th style={{ padding: "14px 20px", minWidth: "90px" }}>{t("Demand Amount")}</th>
//                                                                             {/* <th style={{ padding: "14px 20px", minWidth: "120px" }}>Uploaded Images</th> */}
//                                                                             {/* <th style={{ padding: "14px 20px", minWidth: "90px" }}>Date</th> */}
//                                                                             <th style={{ padding: "14px 20px", minWidth: "120px" }}>{t("View")}</th>
//                                                                             <th style={{ padding: "14px 20px", minWidth: "120px" }}>{t("Actions")}</th>
//                                                                         </tr>
//                                                                     </thead>
//                                                                     <tbody>
//                                                                         {
//                                                                             tableData.map((val, index) => {
//                                                                                 return (
//                                                                                     <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#c6dae7", height: '2rem' }}>
//                                                                                         <td>{index + 1}</td>
//                                                                                         <td>{val.workName}</td>
//                                                                                         <td>{val.ProposalWorkName}</td>
//                                                                                         <td>{val.physicalValue}</td>
//                                                                                         <td>{val.amount}</td>
//                                                                                         {/* <td style={{ verticalAlign: 'middle' }}>
//                                                                                             <button className='btn btn-success btn-sm px-3 my-auto'
//                                                                                                 onClick={(e) => fetchSpecficUploadPhoto(e, val.WorkOrderUID)}
//                                                                                                 style={{
//                                                                                                     cursor: 'pointer',
//                                                                                                     backgroundColor: '#28a745',
//                                                                                                     color: 'white',
//                                                                                                     border: 'none',
//                                                                                                     padding: '6px 8px',
//                                                                                                     borderRadius: '3px',
//                                                                                                     fontSize: "12px",
//                                                                                                     display: "inline-flex",
//                                                                                                     justifyContent: "center",
//                                                                                                     alignItems: 'center',
//                                                                                                     gap: "4px",
//                                                                                                     whiteSpace: "nowrap",

//                                                                                                 }}
//                                                                                             >
//                                                                                                 <img src="/view32.png" alt="View Icon" style={{ width: "14px", height: "14px", opacity: 1 }} /> View Images</button>
//                                                                                         </td> */}
//                                                                                         {/* <td>{new Date(val.currentDate).toLocaleString()}</td> */}
//                                                                                         <td>
//                                                                                             <button className="btn btn-sm btn-primary mx-1" onClick={(e) => { e.preventDefault(); setShowSpecific(3); handleEdit(e, index) }}>{t("View")}</button>
//                                                                                         </td>
//                                                                                         <td>
//                                                                                             {/* <button className="btn btn-sm btn-primary mx-1" onClick={(e) => { e.preventDefault(); setShowSpecific(4); handleEdit(e, index) }}>Edit</button> */}
//                                                                                             <button className="btn btn-sm btn-danger mx-1" onClick={(e) => handleDelete(e, index)}>{t("Delete")}</button>
//                                                                                         </td>
//                                                                                     </tr>

//                                                                                 )
//                                                                             })
//                                                                         }
//                                                                     </tbody>
//                                                                 </table>
//                                                             </div>
//                                                         </div>

//                                                     </div>
//                                                 </div>
//                                             )
//                                         }


//                                         <div className="col-12 elements">
//                                             <div className="row">
//                                                 <div className="col-3 my-auto ">
//                                                     <label className='my-auto'>{t("Remark")}<span className='text-danger fw-bold'>*</span></label>
//                                                 </div>
//                                                 <div className="col-7">
//                                                     <input className='form-control' type='text' name='remark' onChange={(e) => {
//                                                         let value = e.target.value
//                                                             .replace(/[^a-zA-Z0-9\s]/g, "")
//                                                             .replace(/^\s+/, "");
//                                                         handleChange({ target: { name: e.target.name, value } });
//                                                     }} value={data.remark} maxLength={50} placeholder={t("Enter Remark")} />
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         <div className="col-12 elements">
//                                             <div className="row">
//                                                 <div className="col-3  ">
//                                                     <label>{t("File Upload")}<span className='text-danger fw-bold'>*</span></label>
//                                                 </div>
//                                                 <div className="col-7">
//                                                     <input type="file" className='form-control py-2' accept=".pdf,.jpg,.jpeg,.png" id='DemandRequestCopy' onChange={handelDemandFile} />
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         <div style={{ display: 'flex', padding: '1rem 15rem', gap: '10px' }}>
//                                             <button type="submit" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', border: 'none', fontSize: '17px', gap: '4px' }} onClick={handleSubmit}> {t("Submit")}</button>
//                                             <button type='button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: 'red', border: 'none', fontSize: '17px', gap: '4px' }} onClick={(e) => {
//                                                 ResetData(e)
//                                             }} ><img src={Cancel32} style={{ width: '1.2rem', }} /> {t("Cancel")}</button>
//                                         </div>
//                                     </form>



//                                 </div>
//                             </div>

//                         </div>
//                     </div>
//                 )
//             }


//             {
//                 showSpecific == 3 && (
//                     <div className='col-12 pb-5' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//                         <div className="col-12 m-auto">

//                             <div className="col-12 m-auto my-5 budgetContainer">
//                                 <div className="m-auto my-5 budgetElement">

//                                     <div className="col-12 mb-4 mt-3">
//                                         <div className='col-12' style={{ display: "flex", alignItems: "center" }}>
//                                             {/* < img src="/Bill-files64.png" alt="TechnicalSanction" style={{ width: "32px", height: "32px" }} className='my-auto me-2' /> */}
//                                             <h3 className='text-left fw-bold mt-2'>{t("View Demand Request")}</h3>
//                                         </div>
//                                     </div>

//                                     <form >

//                                         {
//                                             editIndex &&
//                                             <div className="col-12">
//                                                 <div className="col-12 m-auto p-4">
//                                                     <form action="">
//                                                         <div className="row">

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Year")}</label>
//                                                                     </div>

//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.year} disabled />
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Head Code")}</label>
//                                                                     </div>

//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.headCode} disabled />
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Work Name")}</label>
//                                                                     </div>

//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.workName} disabled />
//                                                                     </div>

//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Proposal Work Name")}</label>
//                                                                     </div>

//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.ProposalWorkName} disabled />
//                                                                     </div>

//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Technical UID")}</label>
//                                                                     </div>

//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.TechnicalUID} disabled />
//                                                                     </div>

//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Physical Progress UID")}</label>
//                                                                     </div>

//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.PhysicalProgressUID} disabled />
//                                                                     </div>

//                                                                 </div>
//                                                             </div>
//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Physical Value in %")}</label>
//                                                                     </div>

//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.physicalValue} disabled />
//                                                                     </div>

//                                                                 </div>
//                                                             </div>


//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Work Order Amount")}</label>
//                                                                     </div>
//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.WorkOrderAmount} disabled />
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Expenditure Amount")}</label>
//                                                                     </div>
//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.ExpenditureAmount} disabled />
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                             {/* <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>Available Work Order Balance</label>
//                                                                     </div>
//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.AvailableWorkOrderBalance} disabled />
//                                                                     </div>
//                                                                 </div>
//                                                             </div> */}

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Approved Demand Request")}</label>
//                                                                     </div>
//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.ApprovedDemandRequest} disabled />
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Available Work Order Amount")}</label>
//                                                                     </div>
//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.AvailableWorkOrderAmount} disabled />
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Available Amount For Demand Request")}</label>
//                                                                     </div>
//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.AvailableAmountForDemandRequest} disabled />
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Demand Amount")}</label>
//                                                                     </div>
//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.amount} disabled />
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-4 text-center">
//                                                                 <button className='btn btn-danger px-5 fw-bold' onClick={(e) => handleClosetheSpecificwindow(e)}>{t("Close")}</button>
//                                                             </div>

//                                                         </div>
//                                                     </form>
//                                                 </div>
//                                             </div>
//                                         }

//                                     </form>

//                                 </div>
//                             </div>

//                         </div>
//                     </div>
//                 )
//             }


//             {
//                 showSpecific == 4 && (
//                     <div className='col-12 pb-5' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//                         <div className="col-12 m-auto">

//                             <div className="col-12 m-auto my-5 budgetContainer">
//                                 <div className="m-auto my-5 budgetElement">

//                                     <div className="col-12 mb-4 mt-3">
//                                         <div className='col-12' style={{ display: "flex", alignItems: "center" }}>
//                                             {/* < img src="/Bill-files64.png" alt="TechnicalSanction" style={{ width: "32px", height: "32px" }} className='my-auto me-2' /> */}
//                                             <h3 className='text-left fw-bold mt-2'>{t("Edit Demand Request")}</h3>
//                                         </div>
//                                     </div>

//                                     <form >

//                                         {
//                                             editIndex &&
//                                             <div className="col-12">
//                                                 <div className="col-12 m-auto p-4">
//                                                     <form action="">
//                                                         <div className="row">

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Year")}</label>
//                                                                     </div>

//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.year} disabled />
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Head Code")}</label>
//                                                                     </div>

//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.headname} disabled />
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Work Name")}</label>
//                                                                     </div>

//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.workName} disabled />
//                                                                     </div>

//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Proposal Work Name")}</label>
//                                                                     </div>

//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.ProposalWorkName} disabled />
//                                                                     </div>

//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Technical UID")}</label>
//                                                                     </div>

//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.TechnicalUID} disabled />
//                                                                     </div>

//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Physical Progress UID")}</label>
//                                                                     </div>

//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.PhysicalProgressUID} disabled />
//                                                                     </div>

//                                                                 </div>
//                                                             </div>


//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Work Order Amount")}</label>
//                                                                     </div>
//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.WorkOrderAmount} disabled />
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Expenditure Amount")}</label>
//                                                                     </div>
//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.ExpenditureAmount} disabled />
//                                                                     </div>
//                                                                 </div>
//                                                             </div>


//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Approved Demand Request")}</label>
//                                                                     </div>
//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.ApprovedDemandRequest} disabled />
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Available Work Order Amount")}</label>
//                                                                     </div>
//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.AvailableWorkOrderAmount} disabled />
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label>{t("Available Amount For Demand Request")}</label>
//                                                                     </div>
//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.AvailableAmountForDemandRequest} disabled />
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-2">
//                                                                 <div className="row">
//                                                                     <div className="col-6">
//                                                                         <label className='fw-bold'>{t("Demand Request Amount")}</label>
//                                                                     </div>

//                                                                     <div className="col-6">
//                                                                         <input type="text" value={editIndex.amount} name='amount' onChange={(e) => setEditIndex({ ...editIndex, amount: e.target.value })} />
//                                                                     </div>

//                                                                 </div>
//                                                             </div>

//                                                             <div className="col-12 my-4 text-center">
//                                                                 <button disabled={fileProcessing || loading} className='btn btn-success px-5 fw-bold' onClick={(e) => handelchangeTablre(e)}>{t("Submit")}</button>
//                                                             </div>

//                                                         </div>
//                                                     </form>
//                                                 </div>
//                                             </div>
//                                         }

//                                     </form>

//                                 </div>
//                             </div>

//                         </div>
//                     </div>
//                 )
//             }



//             {
//                 showSpecific === 1 &&
//                 (
//                     <div className="col-12" style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" }}>
//                         <div className="col-11 m-auto">
//                             <div className="col-12 PartSection">
//                                 <div className="col-12 py-4">
//                                     <div className="col-12" style={{
//                                         backgroundColor: "white", borderRadius: "8px", padding: "20px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)", marginBottom: "20px"
//                                     }}>
//                                         <h5 className='fw-bold my-4'>{t("Work Name")} : {selectedUploadId}</h5>

//                                         <div className="col-10 m-auto ImageContainer">
//                                             <div className="row">
//                                                 {FetchedImages && FetchedImages.length > 0 && FetchedImages.map((val, index) => {
//                                                     return (
//                                                         <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3 px-2 my-2" >
//                                                             <div className="uploadImagesContainer" style={{ width: "100%", height: "200px", borderRadius: "20px", overflow: "hidden", cursor: "pointer", border: "1px solid black" }} onClick={() => setSelectedImage(`${apiurl}/uploads/${val.Upload}`)} >
//                                                                 <img src={`${apiurl}/uploads/${val.Upload}`} alt="image" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "20px" }} />
//                                                             </div>
//                                                         </div>
//                                                     );
//                                                 })}
//                                                 <div className="col-12 text-center">
//                                                     <button className="btn btn-primary fw-bold px-5 my-4" onClick={() => setShowSpecific(0)}>Back </button>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 )
//             }

//             {selectedImage && (
//                 <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(0,0,0,0.7)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }} onClick={() => setSelectedImage(null)} >
//                     <img src={selectedImage} alt="Uploaded" style={{ maxWidth: "80%", maxHeight: "80%", borderRadius: '10px', boxShadow: '0 0 10px white' }} />
//                 </div>
//             )}


//         </>
//     )
// }

// export default DemandRequest;

import React, { useContext, useEffect, useRef, useState } from 'react';
import "./BudgetEstimation.css";
import Application from "../../StateContext/Application";
import { apiurl } from '../../../../path';
import { Back32, Cancel32, ProposalCreation32, submit } from '../../../../public/LoginImages/importimages';
import * as XLSX from 'xlsx';
import * as exifr from 'exifr';
import { useLanguage } from '../../../../lang/langcontext/LanguageContext';

const DemandRequest = () => {
    const submitLockRef = useRef(false);
    const { language, toggleLanguage, t } = useLanguage();
    const operation = useContext(Application);

    const { GetProjectInfo, GetBudgetHeadInfo, DemandRequest } = operation;

    const [projectId, setProjectId] = useState([]);
    const [HeadId, setHeadID] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [indexofediting, setIndexofEditing] = useState(null);
    const [relatedHeadID, setRelatedHeadID] = useState([]);
    const [loading, setLoading] = useState(false);
    const [WorkNameList, setWorkNameList] = useState([]);
    const [HeadCode, setHeadCode] = useState([]);
    const [district, setDistrict] = useState([]);
    const [selectedUploadId, setSelectedUploadID] = useState();
    const [FetchedImages, setFetchedImages] = useState([]);
    const [showSpecific, setShowSpecific] = useState(0);
    const [selectedImage, setSelectedImage] = useState(null);
    const [DeemandData, setDeemandData] = useState([]);
    const [isDisabled, setIsDisabled] = useState(false);

    // New state to prevent double clicking on ADD button
    const [isAdding, setIsAdding] = useState(false);

    const [processedProposalCopy, setProcessedProposalCopy] = useState(null);
    const [fileProcessing, setFileProcessing] = useState(false);
    const [data, setData] = useState({
        HeadCode: "",
        ProjectID: '',
        ProjectName: '',
        ProjectCost: "0",
        talulka: "",
        piu: "",
        GRCopy: "",
        FinancialYear: '',
        BudgetHeadID: '',
        BudgetHeadName: "",
        BudgetHeadType: "",
        DemandRequestamount: null,
        workName: "",
        ProposalWorkName: "",
        remark: "",
        WorKOrderAmount: "",
        PhysicalValue: "",
        RemainingAmount: 0,
        JOB_ID:""
    });

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     console.log(name, value);

    //     // If MHUID changed -> reset dependent state
    //     if (name === "MHUID") {
    //         setData(prev => ({
    //             ...prev,
    //             [name]: value,
    //             ProposalWorkName: "",
    //             PhysicalValue: "",
    //             WorKOrderAmount: 0,
    //             DemandRequestamount: null,
    //             RemainingAmount: 0
    //         }));
    //         // clear dependent UI/data
    //         setTableData([]);
    //         setDeemandData([]);
    //         setProcessedProposalCopy(null);
    //         setShowSpecific(0);
    //         setIsDisabled(false);
    //         return;
    //     }

    //     // If HeadCode or FinancialYear changed -> reset work-specific fields too
    //     if (name === "HeadCode" || name === "FinancialYear") {
    //         setData(prev => ({
    //             ...prev,
    //             [name]: value,
    //             MHUID: "",
    //             ProposalWorkName: "",
    //             PhysicalValue: "",
    //             WorKOrderAmount: 0,
    //             DemandRequestamount: null,
    //             RemainingAmount: 0
    //         }));
    //         setTableData([]);
    //         setDeemandData([]);
    //         setProcessedProposalCopy(null);
    //         setShowSpecific(0);
    //         return;
    //     }

    //     // If ProposalWorkName changed reset some values (WorkOrderAmount will be set by your useEffect)
    //     if (name === "ProposalWorkName") {
    //         setData(prev => ({
    //             ...prev,
    //             [name]: value,
    //             PhysicalValue: "",
    //             DemandRequestamount: null
    //         }));
    //         setDeemandData([]);
    //         return;
    //     }

    //     // Default
    //     setData(prev => ({ ...prev, [name]: value }));
    // };

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(name, value);
        // If MHUID changed -> reset dependent state
        if (name === "MHUID") {
            setData(prev => ({
                ...prev,
                [name]: value,
                ProposalWorkName: "",
                PhysicalValue: "",
                WorKOrderAmount: 0,
                DemandRequestamount: null,
                RemainingAmount: 0
            }));
            // clear dependent UI/data
            setDeemandData([]);
            setProcessedProposalCopy(null);
            setShowSpecific(0);
            setIsDisabled(false);
            return;
        }
        // If HeadCode or FinancialYear changed -> reset work-specific fields too
        if (name === "HeadCode" || name === "FinancialYear") {
            setData(prev => ({
                ...prev,
                [name]: value,
                MHUID: "",
                ProposalWorkName: "",
                PhysicalValue: "",
                WorKOrderAmount: 0,
                DemandRequestamount: null,
                RemainingAmount: 0
            }));
            setTableData([]);
            setDeemandData([]);
            setProcessedProposalCopy(null);
            setShowSpecific(0);
            return;
        }
        // If ProposalWorkName changed reset some values (WorkOrderAmount will be set by your useEffect)
        if (name === "ProposalWorkName") {
            setData(prev => ({
                ...prev,
                [name]: value,
                PhysicalValue: "",
                DemandRequestamount: null
            }));
            setDeemandData([]);
            return;
        }
        // Default
        setData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        let FileCopy = document.getElementById("DemandRequestCopy").files;
        e.preventDefault();

        // 🔐 HARD BLOCK (sync – instant)
        if (submitLockRef.current) return;
        submitLockRef.current = true;

        // 🚫 UI guard (extra safety)
        if (loading) return;

        // ---------------- VALIDATIONS ----------------
        const missing = [];
        if (!data.FinancialYear) missing.push("Approved Year");
        if (!data.HeadCode) missing.push("Head");
        if (!data.MHUID) missing.push("MHUID Number");
        if (!data.ProposalWorkName) missing.push("Work Name");
        if (!processedProposalCopy) missing.push("Proposal Copy");
        if (!(tableData && tableData.length > 0)) missing.push("At least one Demand entry");

        if (missing.length > 0) {
            alert(`Please fill required before submitting: ${missing.join(", ")}`);
            submitLockRef.current = false; // 🔓 unlock
            return;
        }

        setLoading(true); // 🔒 UI lock
const formData = new FormData();

// append normal data
formData.append("tableData",JSON.stringify( tableData));

// append file
formData.append("DemandRequestCopy", FileCopy[0]);
        try {
            const res = await DemandRequest(formData);

            alert(res.message || "Submitted Successfully");

            // 🚨 IMPORTANT: do NOT unlock before reload
            setTimeout(() => {
                window.location.reload();
            }, 300);

        } catch (error) {
            console.error(error);
            alert("Failed to submit demand request. Please try again.");
            submitLockRef.current = false; // 🔓 unlock only on error
        } finally {
            setLoading(false);
            // ❌ DO NOT unlock here (reload will happen)
        }
    };

    // Fetching
    const FetchData = async () => {

        try {
            let res = await GetProjectInfo('null', "all");
            let res1 = await GetBudgetHeadInfo('null', "all");
            let res3 = await GetBudgetHeadInfo('null', "AllHeadCode");

            console.log("district ------------ ", res3);
            setProjectId(res);
            setHeadID(res1);
            setHeadCode(res3);
        }
        catch (err) {
            console.log(err);
        }
    }

    const HeadIDFetchOperation = async (ID, IDtype) => {
        try {
            console.log(ID);
            if (IDtype == "ProjectId") {
                let res1 = await GetProjectInfo(ID, "id");
                console.log("Project ID ingo :: ", res1);
                let projectData = res1[0];
                console.log("project data i sleected ", projectData);

                let apple = [...new Map(HeadId.filter(item => item.ProjectName === projectData.ProjectName).map(item => [item.HeadName, item])).values()];
                console.log("Head related to project ", apple)
                setRelatedHeadID(apple);


                setData((prev) => ({
                    ...prev,
                    FinancialYear: projectData.FinancialYear,
                    ProjectName: projectData.ProjectName,
                    ProjectID: projectData.ProjectId,
                    ProjectCost: projectData.ProjectCost,
                    piu: projectData.PIU,
                    GRCopy: projectData.GRCopy
                }))
            } else if (IDtype == "HeadID") {
                let res1 = await GetBudgetHeadInfo(ID, 'id');
                console.log("Head ID info ", res1);
                let HeadData = res1[0];
                setData((prev) => ({
                    ...prev,
                    BudgetHeadID: HeadData.HeadID,
                    BudgetHeadName: HeadData.HeadName,
                    BudgetHeadType: HeadData.HeadType
                }))
            }
        }
        catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        FetchData();
    }, [])

    const [tableData, setTableData] = useState([]);

    console.log("data: ", data);

    const FetchDeemandRequest = async () => {
        let HeadID = {
            HeadCode: data.HeadCode,
            FinancialYear: data.FinancialYear,
            ProposalWorkName: data.ProposalWorkName,
            PhysicalValue: data.PhysicalValue
        };

        let res2 = await GetBudgetHeadInfo(HeadID, "GetSpecifcDetailForDemandRequest");
        if (!res2 || res2.length === 0) {
            alert("No progress data found for this work order");
            setDeemandData([]);
            setData(prev => ({ ...prev, PhysicalValue: "", RemainingAmount: 0 }));
            return;
        }

        console.log("Result :: ", res2);

        const { RemainingAmount } = res2[0];
        // store into data state immediately
        setData(prev => ({ ...prev, RemainingAmount }));
        let response = await GetBudgetHeadInfo(HeadID, "GetSpecifcDemandRequest");
        setDeemandData(response);

        const currentPhysical = Number(data.PhysicalValue);
        const Approved = Number(RemainingAmount);
        const validSteps = [30, 50, 100];

        // 🧩 No previous demands
        let hasShownAlert = false;
        if (!response || response.length === 0) {
            if (!hasShownAlert) {
                hasShownAlert = true;
                const allowedAmount = (Approved * 30) / 100;
                if (currentPhysical !== 30) {
                    alert("No previous demand requests, creating 30% demand.");
                }
                setData(prev => ({ ...prev, PhysicalValue: 30, DemandRequestamount: allowedAmount.toFixed(2) }));
            }
            return;
        }

        // ✅ Check if already created
        if (response.some(item => Number(item.PhysicalValue) === currentPhysical)) {
            alert(`You have already created a demand request for ${currentPhysical}%.`);
            setData(prev => ({ ...prev, PhysicalValue: "" }));
            return;
        }

        // ✅ Find the highest existing physical value
        const createdSteps = response.map(item => Number(item.PhysicalValue));
        const maxCreated = Math.max(...createdSteps);
        console.log("Max created physical:", maxCreated);

        // 🧩 Rule: must have previous step
        const currentIndex = validSteps.indexOf(currentPhysical);
        const prevStep = validSteps[currentIndex - 1];

        if (currentIndex > 0 && !createdSteps.includes(prevStep)) {
            alert(`You must first create a demand request for ${prevStep}%.`);
            return;
        }

        // ✅ All checks passed — calculate allowed %
        const allowedPercentage = currentPhysical - maxCreated;
        const allowedAmount = (Approved * allowedPercentage) / 100;

        console.log("Allowed %:", allowedPercentage);
        console.log("Allowed Amount:", allowedAmount);

        setData(prev => ({
            ...prev,
            DemandRequestamount: allowedAmount.toFixed(2),
            PhysicalValue: currentPhysical
        }))
        // Validation
        if (Number(data.DemandRequestamount) > allowedAmount) {
            alert(
                `Demand Request Amount cannot exceed ${allowedPercentage}% of Work Order Amount (${allowedAmount}).`
            );
            return;
        }

    }

    useEffect(() => {
        if (data.PhysicalValue) {
            FetchDeemandRequest();
        }
    }, [data.HeadCode, data.FinancialYear, data.ProposalWorkName, data.PhysicalValue]);

    const AddinTableOperation = async (e) => {
        e.preventDefault();

        // Prevent double execution
        if (isAdding) return;

        // Mandatory checks before adding
        const missing = [];
        if (!data.FinancialYear) missing.push("Approved Year");
        if (!data.HeadCode) missing.push("Head");
        if (!data.MHUID) missing.push("MHUID Number");
        if (!data.ProposalWorkName) missing.push("Work Name");
        if (!data.PhysicalValue) missing.push("Select Physical Value");
        if (data.DemandRequestamount === null || data.DemandRequestamount === "" || Number(data.DemandRequestamount) === 0) missing.push("Demand Request Amount");

        if (missing.length > 0) {
            return alert(`Please fill required fields: ${missing.join(", ")}`);
        }

        setIsAdding(true); // Start loading state

        try {
            let HeadID = {
                HeadCode: data.HeadCode,
                FinancialYear: data.FinancialYear,
                ProposalWorkName: data.ProposalWorkName,
                PhysicalValue: data.PhysicalValue
            }
            let res2 = await GetBudgetHeadInfo(HeadID, "GetSpecifcDetailForDemandRequest");
            if (!res2 || res2.length === 0) {
                alert("No progress data found for this work order");
                return;
            }
            const { ApprovedWorkAmount, RemainingAmount, PaidAmount, BillRemainingAmount, BillPaidAmount, TechnicalUID, UploadID, talulka, physicalValue, WorkOrder_TechnicalID, Progress_TechnicalID, WorkName,JOB_ID } = res2[0];
            console.log("Result :: ", res2);

            let obj = {
                year: data.FinancialYear,
                headCode: data.HeadCode,
                workName: WorkName,
                ProposalWorkName: data.ProposalWorkName,
                district: talulka,
                amount: parseFloat(data.DemandRequestamount).toFixed(2),
                TechnicalUID: WorkOrder_TechnicalID,
                PhysicalProgressUID: UploadID,
                physicalValue: data.PhysicalValue,
                WorkOrderAmount: BillRemainingAmount,
                ExpenditureAmount:BillPaidAmount,
                ApprovedDemandRequest: parseFloat(data.DemandRequestamount).toFixed(2),
                AvailableWorkOrderAmount: BillRemainingAmount,
                AvailableAmountForDemandRequest: RemainingAmount - parseFloat(data.DemandRequestamount).toFixed(2),
                currentDate: new Date().toISOString(),
                JOB_ID:JOB_ID
            }

            // Prevent duplicates
            let isDuplicate = tableData.some((entry) =>
                entry.year === obj.year &&
                entry.headCode === obj.headCode &&
                entry.ProposalWorkName === obj.ProposalWorkName &&
                entry.physicalValue === obj.physicalValue
            );

            if (isDuplicate) {
                alert("Duplicate entry !! This data already exists in the table.");
                return;
            }

            // additional validation: DemandRequestamount should not exceed available
            // if (obj.ApprovedDemandRequest > obj.WorkOrderAmount) {
            //     console.log("amounts of demand",obj.ApprovedDemandRequest , obj.WorkOrderAmount)
            //     alert("Demand Request Amount cannot be greater than Work Order Amount!");
            //     return;
            // }
if (parseFloat(obj.ApprovedDemandRequest) > parseFloat(obj.WorkOrderAmount)) {
    console.log(
      "amounts of demand",
      obj.ApprovedDemandRequest,
      obj.WorkOrderAmount
    );
    alert("Demand Request Amount cannot be greater than Work Order Amount!");
    return;
}

            setTableData((prev) => [...prev, obj]);

            // clear fields after adding except keep Proposal selection for convenience
            setData(prev => ({
                ...prev,
                PhysicalValue: "",
                DemandRequestamount: null
            }));

        } catch (err) {
            console.log("Error :: ", err);
        } finally {
            setIsAdding(false); // Stop loading state
        }
    }

    console.log("table Data :: ", tableData);

    const handleEdit = (e, index) => {
        e.preventDefault();
        const item = tableData[index];
        console.log("table i selected :: ", item)
        setEditIndex(item);
        setIndexofEditing(index);
    };

    const handleDelete = (e, index) => {
        e.preventDefault();
        const updated = tableData.filter((_, i) => i !== index);
        setTableData(updated);
    };

    const handelchangeTablre = (e) => {
        e.preventDefault();
        const updatedData = [...tableData];
        updatedData[indexofediting] = editIndex;
        setTableData(updatedData);
        console.log("Editted Index :: ", editIndex);
        setEditIndex(null);
        setIndexofEditing(null);
        setShowSpecific(0);
    };

    const handleClosetheSpecificwindow = (e) => {
        e.preventDefault();
        setEditIndex(null);
        setIndexofEditing(null);
        setShowSpecific(0);
    };

    const getAllFinancialYears = () => {
        const years = [];
        for (let year = 2024; year <= 2026; year++) {
            const next = (year + 1).toString();
            years.push(`${year}-${next}`);
        }
        return years;
    };

    const fetchSpecficUploadPhoto = async (e, id) => {
        e.preventDefault();
        try {
            let res = await GetBudgetHeadInfo(id, "GetSpecificUploadImagesfromProgressTableUsingWorkOrderNo")
            setFetchedImages(res);
            setSelectedUploadID(id);
            setShowSpecific(1);
        }
        catch (err) {
            console.log(err);
        }
    };
    const FetchSpecificWorkOrder = async (FinancialYear, Head) => {
        console.log(FinancialYear, Head);

        try {
            let res = await GetBudgetHeadInfo("null", "GetAllWorknameFromWorkOrderDetail")
            console.log("res", res);

            let newres = res.filter((item) => item.ProposalYear == FinancialYear && item.HeadCode == Head);
            console.log(newres);

            setWorkNameList(newres);
            setDistrict(newres);
        }
        catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        if (data.FinancialYear && data.HeadCode) {
            FetchSpecificWorkOrder(data.FinancialYear, data.HeadCode);
        }
    }, [data.FinancialYear, data.HeadCode]);

    useEffect(() => {
        if (data.ProposalWorkName !== "") {
            let info = WorkNameList.filter((val) => val.ProposalID?.trim() == data.ProposalWorkName);
            let workorderamount = info[0]?.ApprovedWorkAmount || 0;

            setData({
                ...data,
                WorKOrderAmount: workorderamount
            });
        }
    }, [data.ProposalWorkName]);

    const processFile = (file) => {
        return new Promise(async (resolve, reject) => {
            try {
                const imageTypes = ["image/jpeg", "image/jpg", "image/png"];
                const pdfTypes = ["application/pdf"];

                // ===== IMAGE FILE =====
                if (imageTypes.includes(file.type)) {
                    const exifData = await exifr.parse(file, ['GPSLatitude', 'GPSLongitude']);
                    if (exifData && (exifData.GPSLatitude || exifData.GPSLongitude)) {
                        console.warn(`⚠️ EXIF GPS data found in ${file.name}. It will be stripped.`);
                    }

                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const img = new Image();
                        img.onload = () => {
                            const canvas = document.createElement("canvas");
                            canvas.width = img.width;
                            canvas.height = img.height;
                            const ctx = canvas.getContext("2d");
                            ctx.drawImage(img, 0, 0);

                            canvas.toBlob((blob) => {
                                const cleanedFile = new File([blob], file.name, { type: file.type });
                                resolve(cleanedFile);
                            }, file.type);
                        };


                        img.onerror = reject;
                        img.src = e.target.result;
                    };
                    reader.onerror = reject;
                    reader.readAsDataURL(file);
                    return;
                }

                // ===== PDF FILE =====
                if (pdfTypes.includes(file.type)) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        // Read as ArrayBuffer instead of text
                        const arrayBuffer = e.target.result;
                        const uint8Array = new Uint8Array(arrayBuffer);

                        // Convert to string for pattern matching
                        const textContent = new TextDecoder('latin1').decode(uint8Array);

                        // More precise patterns with context
                        const dangerousPatterns = [
                            /\/JavaScript\s*<</, // JavaScript object definition
                            /\/JS\s*\(/, // JS action with parenthesis
                            /\/AA\s*<</, // Additional Actions object
                            /\/OpenAction\s*<</, // OpenAction object
                            /\/Launch\s*<</, // Launch action object
                            /\/RichMedia\s*<</ // RichMedia object
                        ];

                        const isMalicious = dangerousPatterns.some(pattern => pattern.test(textContent));

                        if (isMalicious) {
                            alert(`⚠️ Suspicious PDF detected in file "${file.name}". The page will reload.`);

                            return reject(new Error("Malicious PDF detected"));
                        }

                        resolve(file); // safe PDF
                    };
                    reader.onerror = reject;
                    reader.readAsArrayBuffer(file); // Changed from readAsText
                    return;
                }

                // ===== OTHER FILE TYPES =====
                resolve(file);

            } catch (error) {
                console.error("Error processing file:", error);
                reject(error);
            }
        });
    };

    // handle file input changes and process files immediately to validate / strip metadata
    const handelDemandFile = async (e) => {
        // const file = e.target.files && e.target.files[0];
           const file = e.target.files[0];
        if (!file) return;
        const allowedTypes = [
            "application/pdf",
            "image/jpeg",
            "image/png",
        ];

        if (!allowedTypes.includes(file.type)) {
            alert("Only PDF, JPG, JPEG, PNG files are allowed");
            e.target.value = ""; // Reset input
            return;
        }
        if (!file) {
            setProcessedProposalCopy(null);
            return;
        }
        setFileProcessing(true);
        try {
            const cleaned = await processFile(file);
            setProcessedProposalCopy(cleaned);
        } catch (err) {
            console.error('Error processing ProposalCopy:', err);
            alert('Invalid Proposal Copy file. Please choose a different file.');
            e.target.value = '';
            setProcessedProposalCopy(null);
        } finally {
            setFileProcessing(false);
        }
    };

    const ResetData = (e) => {
        e.preventDefault();
        setData({
            HeadCode: "",
            FinancialYear: "",
            MHUID: "",
            ProposalWorkName: "",
            DemandRequestamount: 0,
            PhysicalValue: "",
            WorKOrderAmount: 0
        });
        setTableData([]);
        setDeemandData([]);
    }

    const getApprovedDemandRequest = (physicalValue, workOrderAmount) => {
        const pv = Number(physicalValue);
        const woa = Number(workOrderAmount);

        if (pv === 30) return 0;
        if (pv === 50) return woa * 0.30;
        if (pv === 100) return woa * 0.50;

        return 0;
    };

    return (
        <>
            {
                showSpecific === 0 && (
                    <div className='col-12 pb-5' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
                        <div className="col-12 m-auto">

                            {loading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
                                        display: 'flex', justifyContent: 'center', alignItems: 'center'
                                    }}>
                                    <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
                                    <style>
                                        {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                                    </style>
                                </div>
                            )}

                            <div className="col-12 m-auto my-5 budgetContainer">
                                <div className="m-auto my-5 budgetElement">

                                    <div className="col-12 mb-4 mt-3">
                                        <div className='col-12' style={{ display: "flex", alignItems: "center" }}>
                                            < img src="/Bill-files64.png" alt="TechnicalSanction" style={{ width: "32px", height: "32px" }} className='my-auto me-2' />
                                            <h3 className='text-left fw-bold mt-2'>{t("Demand Request")}</h3>
                                        </div>
                                        <div className="col-12 mt-4">
                                            <p className='py-2 ps-1 fw-bold text-danger' style={{ backgroundColor: "#FBE7E7" }}>{t("Note : Fields marked with * are mandatory")}</p>
                                        </div>
                                    </div>

                                    <form >
                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-3 my-auto ">
                                                    <label className='my-auto'>{t("Approved Year")}<span className='text-danger fw-bold'>*</span></label>
                                                </div>
                                                <div className="col-7">
                                                {/* <input type="text" name="FinancialYear" value={data.FinancialYear} className='py-2'  disabled></input> */}
                                                   <select className="form-control" name="FinancialYear" value={data.FinancialYear} onChange={(e) => { handleChange(e) }} required={true} onBlur={handleChange}>
                                                        <option value="" disabled>{t("Select Year")}</option>
                                                        {getAllFinancialYears().map((year) => (<option key={year} value={year}>{year}</option>))}
                                                    </select> 
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-3 my-auto ">
                                                    <label className='my-auto'>{t("Head")}<span className='text-danger fw-bold'>*</span></label>
                                                </div>
                                                <div className="col-7">
                                                    <select name="HeadCode" value={data.HeadCode} className='py-2' onChange={(e) => { handleChange(e) }} required={true} onBlur={handleChange}>
                                                        <option value="">{t("Select Head Code")}</option>
                                                        {
                                                            HeadCode &&
                                                            HeadCode.map((val, index) => (
                                                                <option value={val.HeadID} key={index}>{val.HeadName}</option>
                                                            ))
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-3 my-auto ">
                                                    <label className='my-auto'>{t("MHUID Number")}<span className='text-danger fw-bold'>*</span></label>
                                                </div>
                                                <div className="col-7">
                                                    <select name="MHUID" value={data.MHUID} className='py-2' onChange={handleChange}>
                                                        <option value="">{t("Select MHUID Number")}</option>
                                                        {
                                                            WorkNameList &&
                                                            [...new Map(
                                                                WorkNameList
                                                                    .map((val) => [`${val.ProposalID}`, val])
                                                            ).values()]
                                                                .map((val, index) => (
                                                                    <option
                                                                        key={index}
                                                                        value={val.TechnicalUID}
                                                                    >
                                                                        {val.TechnicalUID}
                                                                    </option>
                                                                ))
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-3 my-auto ">
                                                    <label className='my-auto'>{t("Work Name")}<span className='text-danger fw-bold'>*</span></label>
                                                </div>
                                                <div className="col-7">
                                                    <select name="ProposalWorkName" value={data.ProposalWorkName} className='py-2' onChange={handleChange}>
                                                        <option value="">{t("Select Work Name")}</option>
                                                        {
                                                            WorkNameList &&
                                                            [...new Map(
                                                                WorkNameList.filter((val) => val.WorkOrder_TechnicalID === data.MHUID)
                                                                    .map((val) => [`${val.ProposalID}`, val])
                                                            ).values()]
                                                                .map((val, index) => (
                                                                    <option
                                                                        key={index}
                                                                        value={val.ProposalID}
                                                                    >
                                                                        {val.ProposalID}
                                                                    </option>
                                                                ))
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-3 my-auto ">
                                                    <label className='my-auto'>{t("Select Physical Progress")}<span className='text-danger fw-bold'>*</span></label>
                                                </div>
                                                <div className="col-7">
                                                    <select name="PhysicalValue" value={data.PhysicalValue} className='py-2' onChange={handleChange}>
                                                        <option value="">{t("Select Physical Progress")}</option>
                                                        <option value="30">30</option>
                                                        <option value="50">50</option>
                                                        <option value="100">100</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-3">
                                                    <label >{t("Work Order Amount")}</label>
                                                </div>
                                                <div className="col-7">
                                                    <input className='form-control'
                                                        type='text'
                                                        value={data.RemainingAmount} placeholder='0' disabled />
                                                </div>
                                            </div>
                                        </div>

                                        {
                                            DeemandData &&
                                            DeemandData.length > 0 &&
                                            (
                                                <div className="col-12 my-3">
                                                    <div className="row">

                                                        <div className='col-12'>
                                                            <div style={{ overflowX: "auto", maxWidth: "100%" }}>
                                                                <h4 className='text-center'>{t("Previous Demand Request Of")} {data.MHUID} </h4>
                                                                <table className='m-0 p-0'
                                                                    style={{ width: '100%', borderCollapse: 'collapse', whiteSpace: "nowrap" }}>
                                                                    <thead>
                                                                        <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>

                                                                            <th style={{ padding: "7px 10px", minWidth: "40px" }}>{t("Sr.No")}</th>
                                                                            <th style={{ padding: "14px 20px", minWidth: "180px" }}>{t("Work Name")}</th>
                                                                            <th style={{ padding: "14px 20px", minWidth: "180px" }}>{t("Job ID")}</th>
                                                                            <th style={{ padding: "14px 20px", minWidth: "90px" }}>{t("Physical Value in %")}</th>
                                                                            <th style={{ padding: "14px 20px", minWidth: "90px" }}>{t("MHUID Number")}</th>
                                                                            <th style={{ padding: "14px 20px", minWidth: "90px" }}>{t("Demand Amount")}</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            DeemandData.map((val, index) => {
                                                                                return (
                                                                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#c6dae7", height: '2rem' }}>
                                                                                        <td>{index + 1}</td>
                                                                                        <td>{val.ProposalWorkName}</td>
                                                                                        <td>{val.JOB_ID}</td>
                                                                                        <td>{val.PhysicalValue}</td>
                                                                                        <td>{val.MHUID}</td>
                                                                                        <td>{val.DRAmount}</td>
                                                                                    </tr>

                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            )
                                        }

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-3 my-auto ">
                                                    <label className='my-auto'>{t("Demand Request Amount")}</label>
                                                </div>
                                                <div className="col-7">
                                                    <input className='form-control'
                                                        type='text'
                                                        name='DemandRequestamount'
                                                        onChange={(e) => {
                                                            const value = e.target.value;

                                                            if (!/^\d*\.?\d{0,2}$/.test(value)) return;

                                                            if (Number(value) > Number(data.WorKOrderAmount)) {
                                                                alert("Demand Request Amount cannot be greater than Work Order Amount!");
                                                                setData((prev) => ({
                                                                    ...prev,
                                                                    DemandRequestamount: prev.DemandRequestamount.toFixed(2) || "",
                                                                }));
                                                                return;
                                                            }
                                                            else {
                                                                setData((prev) => ({
                                                                    ...prev,
                                                                    DemandRequestamount: value,
                                                                }));
                                                            }

                                                        }}
                                                        value={data.DemandRequestamount}
                                                        placeholder={t("Amount")} disabled 
                                                         
                                                        />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-11 text-end">
                                            <div className="col-10 m-auto">
                                                <button
                                                    style={{
                                                        backgroundColor: (isDisabled || isAdding) ? '#ccc' : '#f9a318',
                                                        width: "6rem",
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '5px',
                                                        height: '2rem',
                                                        cursor: (isDisabled || isAdding) ? 'not-allowed' : 'pointer'
                                                    }}
                                                    disabled={isDisabled || isAdding}
                                                    onClick={AddinTableOperation}
                                                >
                                                    {isAdding ? "Adding..." : t("ADD")}
                                                </button>
                                            </div>
                                        </div>

                                        {
                                            tableData &&
                                            tableData.length > 0 &&
                                            (
                                                <div className="col-12 my-3">
                                                    <div className="row">

                                                        <div className='col-12 tableContainer100'>
                                                            <div style={{ overflowX: "auto", maxWidth: "100%" }}>
                                                                <table className='m-0 p-0'
                                                                    style={{ width: '100%', borderCollapse: 'collapse', whiteSpace: "nowrap" }}>
                                                                    <thead>
                                                                        <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>

                                                                            <th style={{ padding: "7px 10px", minWidth: "40px" }}>{t("Sr.No")}</th>
                                                                            <th style={{ padding: "14px 20px", minWidth: "180px" }}>{t("Work Name")}</th>
                                                                            <th style={{ padding: "14px 20px", minWidth: "180px" }}>{t("Proposal Work Name")}</th>
                                                                            <th style={{ padding: "14px 20px", minWidth: "180px" }}>{t("Job ID")}</th>
                                                                            <th style={{ padding: "14px 20px", minWidth: "90px" }}>{t("Physical Value")}</th>
                                                                            <th style={{ padding: "14px 20px", minWidth: "90px" }}>{t("Demand Amount")}</th>
                                                                            <th style={{ padding: "14px 20px", minWidth: "120px" }}>{t("View")}</th>
                                                                            <th style={{ padding: "14px 20px", minWidth: "120px" }}>{t("Actions")}</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            tableData.map((val, index) => {
                                                                                return (
                                                                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#c6dae7", height: '2rem' }}>
                                                                                        <td>{index + 1}</td>
                                                                                        <td>{val.workName}</td>
                                                                                        <td>{val.ProposalWorkName}</td>
                                                                                         <td>{val.JOB_ID}</td>
                                                                                        <td>{val.physicalValue}</td>
                                                                                        <td>{val.amount}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-sm btn-primary mx-1" onClick={(e) => { e.preventDefault(); setShowSpecific(3); handleEdit(e, index) }}>{t("View")}</button>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button className="btn btn-sm btn-danger mx-1" onClick={(e) => handleDelete(e, index)}>{t("Delete")}</button>
                                                                                        </td>
                                                                                    </tr>

                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            )
                                        }

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-3 my-auto ">
                                                    <label className='my-auto'>{t("Remark")} </label>
                                                </div>
                                                <div className="col-7">
                                                    <input className='form-control' type='text' name='remark' onChange={(e) => {
                                                        let value = e.target.value
                                                            .replace(/[^a-zA-Z0-9\s]/g, "")
                                                            .replace(/^\s+/, "");
                                                        handleChange({ target: { name: e.target.name, value } });
                                                    }} value={data.remark} maxLength={50} placeholder={t("Enter Remark")} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-3  ">
                                                    <label>{t("File Upload")}<span className='text-danger fw-bold'>*</span></label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="file" className='form-control py-2' accept=".pdf,.jpg,.jpeg,.png" id='DemandRequestCopy' onChange={handelDemandFile} />
                                                </div>
                                            </div>
                                        </div>

                                        <div style={{ display: 'flex', padding: '1rem 15rem', gap: '10px' }}>
                                            <button
                                                type="button"
                                                onClick={handleSubmit}
                                                disabled={loading || submitLockRef.current}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    borderRadius: "20px",
                                                    width: "8rem",
                                                    height: "2.5rem",
                                                    background: loading
                                                        ? "#a0a0a0"
                                                        : "linear-gradient(to Right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                                    border: "none",
                                                    fontSize: "17px",
                                                    gap: "6px",
                                                    cursor: loading ? "not-allowed" : "pointer",
                                                    opacity: loading ? 0.7 : 1
                                                }}
                                            >
                                                {loading ? "Submitting..." : "Submit"}
                                            </button>

                                            <button type='button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: 'red', border: 'none', fontSize: '17px', gap: '4px' }} onClick={(e) => {
                                                ResetData(e)
                                            }} ><img src={Cancel32} style={{ width: '1.2rem', }} /> {t("Cancel")}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>

                        </div>
                    </div>
                )
            }

            {
                showSpecific == 3 && (
                    <div className='col-12 pb-5' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
                        <div className="col-12 m-auto">

                            <div className="col-12 m-auto my-5 budgetContainer">
                                <div className="m-auto my-5 budgetElement">

                                    <div className="col-12 mb-4 mt-3">
                                        <div className='col-12' style={{ display: "flex", alignItems: "center" }}>
                                            <h3 className='text-left fw-bold mt-2'>{t("View Demand Request")}</h3>
                                        </div>
                                    </div>

                                    <form >
                                        {
                                            editIndex &&
                                            <div className="col-12">
                                                <div className="col-12 m-auto p-4">
                                                    <form action="">
                                                        <div className="row">

                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Year")}</label>
                                                                    </div>

                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.year} disabled />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Head Code")}</label>
                                                                    </div>

                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.headCode} disabled />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Work Name")}</label>
                                                                    </div>

                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.workName} disabled />
                                                                    </div>

                                                                </div>
                                                            </div>

                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Proposal Work Name")}</label>
                                                                    </div>

                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.ProposalWorkName} disabled />
                                                                    </div>

                                                                </div>
                                                            </div>
<div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("JOB ID")}</label>
                                                                    </div>

                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.JOB_ID} disabled />
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("MHUID Number")}</label>
                                                                    </div>

                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.TechnicalUID} disabled />
                                                                    </div>

                                                                </div>
                                                            </div>

                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Physical Progress UID")}</label>
                                                                    </div>

                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.PhysicalProgressUID} disabled />
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Physical Value in %")}</label>
                                                                    </div>

                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.physicalValue} disabled />
                                                                    </div>

                                                                </div>
                                                            </div>


                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Work Order Amount")}</label>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.WorkOrderAmount} disabled />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Expenditure Amount")}</label>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.ExpenditureAmount} disabled />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Approved Demand Request")}</label>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <input
                                                                            type="text"
                                                                            value={getApprovedDemandRequest(
                                                                                editIndex.physicalValue,
                                                                                editIndex.WorkOrderAmount
                                                                            )}
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Available Work Order Amount")}</label>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.AvailableWorkOrderAmount} disabled />
                                                                    </div>
                                                                </div>
                                                            </div> */}

                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Available Amount For Demand Request")}</label>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <input type="text" value={
                                                                            Number(editIndex.AvailableAmountForDemandRequest) -
                                                                            getApprovedDemandRequest(
                                                                                editIndex.physicalValue,
                                                                                editIndex.WorkOrderAmount
                                                                            ).toFixed(2)}
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Demand Amount")}</label>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.amount} disabled />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-12 my-4 text-center">
                                                                <button className='btn btn-danger px-5 fw-bold' onClick={(e) => handleClosetheSpecificwindow(e)}>{t("Close")}</button>
                                                            </div>

                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        }

                                    </form>

                                </div>
                            </div>

                        </div>
                    </div>
                )
            }

            {
                showSpecific == 4 && (
                    <div className='col-12 pb-5' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
                        <div className="col-12 m-auto">

                            <div className="col-12 m-auto my-5 budgetContainer">
                                <div className="m-auto my-5 budgetElement">

                                    <div className="col-12 mb-4 mt-3">
                                        <div className='col-12' style={{ display: "flex", alignItems: "center" }}>
                                            <h3 className='text-left fw-bold mt-2'>{t("Edit Demand Request")}</h3>
                                        </div>
                                    </div>

                                    <form >

                                        {
                                            editIndex &&
                                            <div className="col-12">
                                                <div className="col-12 m-auto p-4">
                                                    <form action="">
                                                        <div className="row">

                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Year")}</label>
                                                                    </div>

                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.year} disabled />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Head Code")}</label>
                                                                    </div>

                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.headname} disabled />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Work Name")}</label>
                                                                    </div>

                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.workName} disabled />
                                                                    </div>

                                                                </div>
                                                            </div>

                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Proposal Work Name")}</label>
                                                                    </div>

                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.ProposalWorkName} disabled />
                                                                    </div>

                                                                </div>
                                                            </div>

                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Technical UID")}</label>
                                                                    </div>

                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.TechnicalUID} disabled />
                                                                    </div>

                                                                </div>
                                                            </div>

                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Physical Progress UID")}</label>
                                                                    </div>

                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.PhysicalProgressUID} disabled />
                                                                    </div>

                                                                </div>
                                                            </div>


                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Work Order Amount")}</label>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.WorkOrderAmount} disabled />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Expenditure Amount")}</label>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.ExpenditureAmount} disabled />
                                                                    </div>
                                                                </div>
                                                            </div>


                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Approved Demand Request")}</label>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.ApprovedDemandRequest} disabled />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Available Work Order Amount")}</label>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.AvailableWorkOrderAmount} disabled />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>{t("Available Amount For Demand Request")}</label>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.AvailableAmountForDemandRequest.toFixed(2)} disabled />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-12 my-2">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label className='fw-bold'>{t("Demand Request Amount")}</label>
                                                                    </div>

                                                                    <div className="col-6">
                                                                        <input type="text" value={editIndex.amount.toFixed(2)} name='amount' onChange={(e) => setEditIndex({ ...editIndex, amount: e.target.value })} />
                                                                    </div>

                                                                </div>
                                                            </div>

                                                            <div className="col-12 my-4 text-center">
                                                                <button disabled={fileProcessing || loading} className='btn btn-success px-5 fw-bold' onClick={(e) => handelchangeTablre(e)}>{t("Submit")}</button>
                                                            </div>

                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        }

                                    </form>

                                </div>
                            </div>

                        </div>
                    </div>
                )
            }

            {
                showSpecific === 1 &&
                (
                    <div className="col-12" style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" }}>
                        <div className="col-11 m-auto">
                            <div className="col-12 PartSection">
                                <div className="col-12 py-4">
                                    <div className="col-12" style={{
                                        backgroundColor: "white", borderRadius: "8px", padding: "20px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)", marginBottom: "20px"
                                    }}>
                                        <h5 className='fw-bold my-4'>{t("Work Name")} : {selectedUploadId}</h5>

                                        <div className="col-10 m-auto ImageContainer">
                                            <div className="row">
                                                {FetchedImages && FetchedImages.length > 0 && FetchedImages.map((val, index) => {
                                                    return (
                                                        <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3 px-2 my-2" >
                                                            <div className="uploadImagesContainer" style={{ width: "100%", height: "200px", borderRadius: "20px", overflow: "hidden", cursor: "pointer", border: "1px solid black" }} onClick={() => setSelectedImage(`${apiurl}/uploads/${val.Upload}`)} >
                                                                <img src={`${apiurl}/uploads/${val.Upload}`} alt="image" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "20px" }} />
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                                <div className="col-12 text-center">
                                                    <button className="btn btn-primary fw-bold px-5 my-4" onClick={() => setShowSpecific(0)}>Back </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            {selectedImage && (
                <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(0,0,0,0.7)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }} onClick={() => setSelectedImage(null)} >
                    <img src={selectedImage} alt="Uploaded" style={{ maxWidth: "80%", maxHeight: "80%", borderRadius: '10px', boxShadow: '0 0 10px white' }} />
                </div>
            )}
        </>
    )
}

export default DemandRequest;